import createReactComponent from '../createReactComponent';
export default createReactComponent('circle-letter-g', 'IconCircleLetterG', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  [
    'path',
    { d: 'M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1', key: 'svg-1' },
  ],
]);
